/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */

import findIndex from 'lodash/findIndex'
import groupBy from 'lodash/groupBy'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_REGIONS } from '../../actions.type'
import {
  CREATE_REGION,
  REMOVE_REGION,
  SET_REGION_ALL_REQUEST,
  SET_REGION_ALL_VALUE,
  UPDATE_REGION
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  regionAllValue: (state) => state.all.value,
  regionAllRequest: (state) => state.all.request,
  regionAllById: (state) => keyBy(state.all.value, 'id'),
  regionAllByCountryId: (state) => groupBy(state.all.value, 'country.id')
}

const actions = {
  async [FETCH_REGIONS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('region', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_REGION_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_REGION_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_REGION_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_REGION_ALL_VALUE, data)
    } catch (e) {
      commit(SET_REGION_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_REGION({ commit }, value) {
    commit(CREATE_REGION, value)
  },

  async SOCKET_UPDATE_REGION({ commit }, value) {
    commit(UPDATE_REGION, value)
  },

  async SOCKET_REMOVE_REGION({ commit }, id) {
    commit(REMOVE_REGION, id)
  }
}

const mutations = {
  [SET_REGION_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_REGION_ALL_VALUE](state, regions) {
    state.all.value = regions
  },
  [UPDATE_REGION](state, updatedRegion) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedRegion.id }),
      1,
      updatedRegion
    )
  },
  [CREATE_REGION](state, createdRegion) {
    state.all.value.push(createdRegion)
  },
  [REMOVE_REGION](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
